module.exports = __webpack_public_path__ + "static/media/fl_logo.770ab306.png";